import classNames from './CommunicationProblemModal.module.scss';
import classes from 'classnames';
import { useTranslation } from 'react-i18next';
import { Transition } from 'react-transition-group';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch } from '@/store';
import userThunks from '@/store/thunks/user';
import { authActions } from '@/store/reducers/auth';

import TheButton from '@/components/TheButton/TheButton';
import AppBackdrop from '@/components/AppBackdrop';
import AppModal from '@/components/AppModal';

import oppsImage from '@/assets/images/opps.png';

interface CommunicationProblemModalProps {
  show: boolean;
  onRefresh: () => void;
  error?: { status?: number; message?: string } | null;
}

const CommunicationProblemModal = ({ show, onRefresh, error }: CommunicationProblemModalProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const handleButtonClick = async () => {
    if (error?.status === 401 && error?.message === 'Access denied') {
      try {
        await dispatch(userThunks.signOut());
      } catch (e) {
        console.error('Error during sign out:', e);
      }
      dispatch(authActions.signOut());
      navigate('/login', { replace: true });
    } else {
      onRefresh();
    }
  };

  return (
    <Transition
      in={show}
      timeout={400}
      mountOnEnter
      unmountOnExit
      children={state => {
        return (
          <>
            <AppBackdrop className={classes(classNames.backdrop, `backdrop-${state}`)} />
            <AppModal className={classNames.appModal}>
              <div className={classes(classNames.modal, `fade-${state}`)}>
                <img src={oppsImage} />
                <h2>{t('CommunicationProblemModalTitle')}</h2>
                <span
                  className={classNames.description}
                  dangerouslySetInnerHTML={{
                    __html: t('CommunicationProblemModalDescription').toString(),
                  }}
                />
                <TheButton
                  className={classNames.closeBtn}
                  text={t('refresh')}
                  shouldRecolor={false}
                  emitOnClick={handleButtonClick}
                />
              </div>
            </AppModal>
          </>
        );
      }}
    />
  );
};

export default CommunicationProblemModal;
